module.exports = __webpack_public_path__ + "img/swift.e756fad0.png";